export { getServerSideProps, default } from 'components/auth/LoginPage'
